import { takeLatest, call, put } from "redux-saga/effects";
import {
  sendOffer as sendOfferAction,
  setWebRTCState,
  setWebRTCError,
  WebRTCConnectionState,
  attemptWebSocketConnect,
  requestWebSocketPing,
  setWebSocketState,
  WebSocketConnectionState,
} from "./connectionSlice";
import {
  getWSService,
  sendOffer as sendOfferFromClient,
} from "@utils/api-communication/WebSocketCli";

// Saga for handling WebRTC offer sending
function* handleSendOffer() {
  try {
    const wsService = getWSService();

    if (!wsService.isOpen) {
      yield put(setWebRTCError("WebSocket not connected. Cannot send WebRTC offer."));
      return;
    }

    yield put(setWebRTCState(WebRTCConnectionState.CONNECTING));

    yield call(sendOfferFromClient);

    console.log("WebRTC offer sent through saga");
  } catch (error) {
    console.error("Error sending WebRTC offer:", error);
    yield put(setWebRTCError(`Error sending WebRTC offer: ${error.message}`));
  }
}

function* handleWebSocketConnect() {
  try {
    yield put(setWebSocketState(WebSocketConnectionState.CONNECTING));

    yield call(getWSService);

    console.log("WebSocket connection requested through saga");

    // Note: We don't need to put a success action here because
    // the WebSocketCli will dispatch setWebSocketState and setWebSocketOpen
    // actions when the connection succeeds or fails
  } catch (error) {
    console.error("Error connecting WebSocket:", error);
    yield put(setWebSocketState(WebSocketConnectionState.DISCONNECTED));
  }
}

function* handleWebSocketPingRequest() {
  try {
    const wsService = getWSService();
    if (wsService?.isOpen) {
      yield call([wsService, wsService.sendPing]);
    }
  } catch (error) {
    console.error("Error sending WebSocket ping:", error);
  }
}

export default function* connectionSagas() {
  yield takeLatest(sendOfferAction.type, handleSendOffer);

  yield takeLatest(attemptWebSocketConnect.type, handleWebSocketConnect);

  yield takeLatest(requestWebSocketPing.type, handleWebSocketPingRequest);
}
